/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_AI_ACTION_CHECK_RESULT = gql`
  query GetAiActionCheckResult($id: ID!) {
    aiActionCheckResult(id: $id) {
      id
      passed
      actionComplete {
        images {
          id
          url
        }
      }
    }
  }
`
